import { Fade } from '@mui/material';
import IconCircle from 'assets/supplier/circle-icon-check.inline.svg';
import React, { useState } from 'react';
import tw, { css } from 'twin.macro';

const cssBase = css`
	${tw`relative border border-grey-E rounded-15 w-200 sm:w-300 xl:w-170 mx-auto my-10 xl:my-0`};
	:hover {
		${tw`bg-grey-E`}
		cursor: pointer;
	}
`;

export default function BenefitItem({ isMobile, title, Image, ...props }) {
	const [showImage, setShowImage] = useState(true);

	return (
		<div
			css={[ cssBase ]}
			onMouseEnter={() => setShowImage(false)}
			onMouseLeave={() => setShowImage(true)}
			{...props}
		>
			<Fade in={showImage} timeout={{ enter: 1000, exit: 100 }}>
				<div
					css={[ isMobile && tw`w-60 h-60` ]}
					className='w-60 h-60 pointer-events-none absolute left-0 -mt-05 -ml-15'
				>
					{Image}
				</div>
			</Fade>
			<Fade in={!showImage} timeout={{ enter: 1000, exit: 100 }}>
				<div className='pointer-events-none absolute mt-05 xs:mt-10 -ml-10'>
					<IconCircle />
				</div>
			</Fade>
			<p className='font-medium text-11 py-16 w-full text-center pl-10 sm:pl-0 xl:pl-10'>{title}</p>
		</div>
	);
}
